exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compare-selected-emps {\n  margin-top: 15px; }\n\n.compare-emp {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  font-weight: bold; }\n  .compare-emp + .compare-emp {\n    margin-top: 10px; }\n  .compare-emp button {\n    margin-left: 5px;\n    border: none;\n    background: none;\n    cursor: pointer; }\n    .compare-emp button svg {\n      fill: #bb2525; }\n\n.compare-profiles {\n  margin-top: 30px; }\n  .compare-profiles h4 {\n    margin-bottom: 5px; }\n  .compare-profiles .msg {\n    margin-top: 5px; }\n", ""]);

// exports
